import React from 'react';

import { Skeleton } from 'antd';

import styles from './SkeletonLoader.module.scss';

export const SkeletonLoader: React.FC = () => {
  return (
    <div className={styles.loaderWrapper}>
      <Skeleton title={{ width: '100%' }} paragraph={{ rows: 10 }} active loading />
      <Skeleton title={{ width: '100%' }} paragraph={{ rows: 0 }} active loading />
    </div>
  );
};
